import { render, staticRenderFns } from "./StockMovementList.vue?vue&type=template&id=4818fb50&scoped=true&"
import script from "./StockMovementList.vue?vue&type=script&lang=js&"
export * from "./StockMovementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818fb50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4818fb50')) {
      api.createRecord('4818fb50', component.options)
    } else {
      api.reload('4818fb50', component.options)
    }
    module.hot.accept("./StockMovementList.vue?vue&type=template&id=4818fb50&scoped=true&", function () {
      api.rerender('4818fb50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/stock/stock-movement/StockMovementList.vue"
export default component.exports